import { cn } from "@/lib/utils";
import { forwardRef, HTMLProps } from "react";

export const FormCol = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      className={cn("flex flex-col gap-4 w-full ", className)}
      ref={ref}
      {...props}
    />
  ),
);
